export default "__VITE_ASSET__d5f4b3d5__"